// Enums
const DocumentType = {
  TAHAKKUK: "TAHAKKUK",
  TAHSILAT: "TAHSILAT",
  TEDIYE: "TEDIYE",
  TAHAKKUK_SGK: "TAHAKKUK_SGK",
  TAHAKKUK_VERGI: "TAHAKKUK_VERGI",
  TAHAKKUK_STOPAJ: "TAHAKKUK_STOPAJ",
  TAHAKKUK_DIGER: "TAHAKKUK_DIGER",
  TAHAKKUK_DT: "TAHAKKUK_DT",
};

const PaymentType = {
  NAKIT: "NAKIT",
  CEK: "CEK",
  BANKA: "BANKA",
  VIRMAN: "VIRMAN",
  POS: "POS",
};
const TypeOfActiviy = [
  { value: "AL_SAT", label: "AL SAT" },
  { value: "URETIM", label: "ÜRETİM" },
  { value: "HIZMET", label: "HİZMET" },
  { value: "ITHALAT", label: "İTHALAT" },
  { value: "IHRACAT", label: "İHRACAT" },
];

export { DocumentType, PaymentType, TypeOfActiviy };
